// 个人偏好设置
<template>
<div>
  <settings />
  <!-- 消息通知设置 -->
  <msgNotifi />
</div>
</template>
<script>
  // components
  import settings from "./components/settings.vue";
  import msgNotifi from "./components/msgNotifi.vue";

  export default {
    components:{
      settings,
      msgNotifi
    },
    data () {
      // 这里存放数据
      return {
        activeName:'signSetting'
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  /deep/ .el-tabs__nav{
    transform: translateX(20px) !important;
  }
  // @import url(); 引入公共css类
</style>



// WEBPACK FOOTER //
// pages/tpl/Preferences.vue